'use client'

export default function Loading() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
      }}
    >
      <div
        style={{
          display: 'inline-block',
          borderTop: '2px solid currentcolor',
          borderRight: '2px solid currentcolor',
          borderBottomStyle: 'solid',
          borderLeftStyle: 'solid',
          borderRadius: '99999px',
          borderBottomWidth: '2px',
          borderLeftWidth: '2px',
          borderBottomColor: 'transparent',
          borderLeftColor: 'transparent',
          animation: '0.45s linear 0s infinite normal none running spin',
          width: '24px',
          height: '24px',
        }}
      >
        <span
          style={{
            border: '0px',
            clip: 'rect(0px, 0px, 0px, 0px)',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: '0px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            position: 'absolute',
          }}
        >
          Loading...
        </span>
      </div>
    </div>
  )
}
